export enum ModalCloseReasonEnum {
    Close,
    Success,
    Error
}
